




















































import ContactLensFKU from '@/models/item/fku/contact-lens'
import { log } from '@spa/log'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ContactLensItemDetailStore from './store'

@Component
/**
 * Safari(iOS, Mac共に)ではセレクトボックス内の中央寄せに対応していない。
 * そのため、中央寄せするために、このコンポーネントではセレクトボックスのopacityを0にして、その上に表示用の要素をオーバーレイすることで、中央寄せを可能にしている。
 * 留意事項1: 純粋にCSSで解決できればassetsの方でスタイル定義してより汎用的なものとしたいが、表示用の要素のテキストをJSで書き換えているため、Vue側でスタイル定義も行っている。
 * 留意事項2: Safariの場合に中央寄せしたい、というユースケースが広く見られる場合は、Vueコンポーネントとしてもより汎用化したい。
 */
export default class ContactLensColorDropdown extends Vue {
  @Prop({ required: true })
  id: string

  @Prop({ required: true })
  store: ContactLensItemDetailStore | null

  @Prop({ required: true })
  isLoading: boolean

  get selectBoxClass(): string[] {
    return [
      'dropdown', 'dropdown--color',
    ]
  }

  /**
   * セレクトボックス本体を隠して、（中央寄せのために）オーバーレイ表示されるDOM要素のテキスト
   */
  get overlayLabel(): string {
    return this.selectedFku ? this.getColorLabel(this.selectedFku) : ''
  }

  get selectedFku(): ContactLensFKU | null {
    if (this.store && this.store.selectedFku) {
      return this.store.selectedFku
    }

    return this.fkus[0]
  }

  get selectedFkuShortId(): string {
    const selected = this.selectedFku

    return selected ? selected.shortId : ''
  }

  get fkus(): ContactLensFKU[] {
    return this.store ? this.store.fkus : []
  }

  getColorLabel(fku: ContactLensFKU): string {
    if (fku.color === null) {
      log.warn('fku has not color.', fku)

      return ''
    }

    return fku.color.label
  }

  onChange($event): void {
    if (!this.store) {
      log.error('this.store is null')

      return
    }

    const selectedFku = this.fkus.find(fku => fku.shortId === $event.target.value)

    if (!selectedFku) {
      log.error(`fku with shortId ${$event.target.value} not found from this.fkus`)

      return
    }

    this.select(selectedFku)
  }

  private select(selected: ContactLensFKU): void {
    if (this.store) {
      this.store.selectFku(selected)
    }
  }
}
